<template>
  <p
    v-if="sale.xAnnouncements && sale.xAnnouncements.status === 'stopped'"
    class="text-yellow-700 dark:text-yellow-400 mt-3 text-sm"
    role="status"
    data-cy="gumroad-announcement-warning"
  >
    X announcements stopped.
    <template v-if="sale.xAnnouncements.reason === 'reconnect_x'">
      Reconnect X for future sales.
    </template>
    <template v-else-if="sale.xAnnouncements.reason === 'retry_limit'">
      Retry limit reached.
    </template>
    <template v-else-if="sale.xAnnouncements.reason === 'outcome_unknown'">
      We couldn't confirm the last post, so we stopped to avoid duplicates.
    </template>
    <template v-else>We couldn't publish the sale announcements.</template>
    <template v-if="!sale.hasEnded && !sale.wasCanceled">
      Your sale will still end as scheduled.
    </template>
  </p>
</template>

<script>
  export default {
    props: {
      sale: { type: Object, required: true },
    },
  };
</script>
